import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/login'
import DlsOne from '@/pages/dlsOne'
import DlsTwo from '@/pages/dlsTwo'
import BmOne from '@/pages/bmOne'
import HxOne from '@/pages/hxOne'
import Goods from '@/pages/goods'
import Order from '@/pages/order'
import OdInfo from '@/pages/odInfo'
import GlyNbmg from '@/pages/glyNbmg'
import GlyMg from '@/pages/glyMg'
import GlyMd from '@/pages/GlyMd'
import GlyYhtj from '@/pages/glyYhtj'
import GlyYstj from '@/pages/glyYstj'
import GlyYsmx from '@/pages/glyYsmx'
import GlyJye from '@/pages/glyJye'
import GlyJyemx from '@/pages/glyJyemx'
import GlyBanner from '@/pages/glyBanner'
import ceshi from '@/pages/ceshi'
import a from '@/pages/a'
import d from '@/pages/d'
import e from '@/pages/e'

Vue.use(Router)

export default new Router({
  routes: [
    {name: 'login',path: '/',component: Login},
    {name: 'dlsOne',path: '/dlsOne',component: DlsOne},
    {name: 'dlsTwo',path: '/dlsTwo',component: DlsTwo},
    {name: 'bmOne',path: '/bmOne',component: BmOne},
    {name: 'hxOne',path: '/hxOne',component: HxOne},
    {name: 'goods',path: '/goods',component: Goods},
    {name: 'order',path: '/order',component: Order},
    {name: 'odInfo',path: '/odInfo',component: OdInfo},
    {name: 'glyNbmg',path: '/glyNbmg',component: GlyNbmg},
    {name: 'glyMg',path: '/glyMg',component: GlyMg},
    {name: 'glyMd',path: '/glyMd',component: GlyMd},
    {name: 'glyYhtj',path: '/glyYhtj',component: GlyYhtj},
    {name: 'glyYstj',path: '/glyYstj',component: GlyYstj},
    {name: 'glyYsmx',path: '/glyYsmx',component: GlyYsmx},
    {name: 'glyJye',path: '/glyJye',component: GlyJye},
    {name: 'glyJyemx',path: '/glyJyemx',component: GlyJyemx},
    {name: 'glyBanner',path: '/glyBanner',component: GlyBanner},
    {name: 'ceshi',path: '/ceshi',component: ceshi},
    {name: 'a',path: '/a',component: a},
    {name: 'd',path: '/d',component: d},
    {name: 'e',path: '/e',component: e}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js